(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fino-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function initUGC(root){
    all('[data-ltg-ugc]',root).forEach(function(sec){
      if(sec.__ltgUgcBound)return;
      sec.__ltgUgcBound=true;
      var rail=sec.querySelector('[data-ltg-ugc-rail]');
      if(!rail)return;
      var videos=all('video',rail);
      var prev=sec.querySelector('[data-ltg-ugc-prev]');
      var next=sec.querySelector('[data-ltg-ugc-next]');
      function scroll(d){rail.scrollBy({left:d*Math.max(260,rail.clientWidth*0.8),behavior:reduce?'auto':'smooth'});}
      if(prev)prev.addEventListener('click',function(){scroll(-1);});
      if(next)next.addEventListener('click',function(){scroll(1);});
      videos.forEach(function(v){
        var card=v.closest('[data-ltg-ugc-card]');
        var play=card?card.querySelector('[data-ltg-ugc-play]'):null;
        if(play)play.addEventListener('click',function(){videos.forEach(function(o){if(o!==v)o.pause();});v.controls=true;var p=v.play();if(p&&p.catch)p.catch(function(){});});
        v.addEventListener('play',function(){v.controls=true;if(card)card.classList.add('is-playing');videos.forEach(function(o){if(o!==v)o.pause();});});
        v.addEventListener('pause',function(){v.controls=false;if(card)card.classList.remove('is-playing');});
        v.addEventListener('ended',function(){v.controls=false;if(card)card.classList.remove('is-playing');v.currentTime=0;});
      });
      if('IntersectionObserver'in window){
        var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting){var vv=e.target.querySelector('video');if(vv)vv.pause();}});},{threshold:.35});
        all('[data-ltg-ugc-card]',rail).forEach(function(c){io.observe(c);});
        sec.__ltgObserver=io;
      }
    });
  }
  if(document.readyState!=='loading')initUGC(document);
  else document.addEventListener('DOMContentLoaded',function(){initUGC(document);});
  document.addEventListener('shopify:section:load',function(e){initUGC(e.target);});
  document.addEventListener('shopify:section:unload',function(e){all('[data-ltg-ugc]',e.target).forEach(function(n){if(n.__ltgObserver)n.__ltgObserver.disconnect();delete n.__ltgUgcBound;});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lattogo-main-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root||document).querySelectorAll('[data-ltg-gallery]').forEach(function(g){
      if(g.__ltgGalBound)return;
      g.__ltgGalBound=true;
      var mainWrap=g.querySelector('[data-ltg-main]');
      var mainImg=g.querySelector('[data-ltg-main-img]');
      var thumbs=[].slice.call(g.querySelectorAll('[data-ltg-gthumb]'));
      var moreBtn=g.querySelector('[data-ltg-more]');
      var lb=g.querySelector('[data-ltg-lb]');
      var lbImg=lb?lb.querySelector('img'):null;
      var images=[];
      var dataEl=g.querySelector('[data-ltg-images]');
      try{images=JSON.parse(dataEl.textContent);}catch(e){}
      var cur=parseInt(mainImg&&mainImg.getAttribute('data-index')||'0',10)||0;
      function setMain(i){
        if(i<0||i>=images.length)return;
        cur=i;
        if(mainImg){mainImg.src=images[i].u;mainImg.setAttribute('data-index',i);}
        thumbs.forEach(function(t){t.setAttribute('aria-current',String(t.getAttribute('data-index'))===String(i)?'true':'false');});
      }
      thumbs.forEach(function(t){t.addEventListener('click',function(){setMain(parseInt(t.getAttribute('data-index'),10));});});
      function show(i){if(!images.length)return;cur=(i+images.length)%images.length;if(lbImg)lbImg.src=images[cur].u;}
      function open(i){if(!lb)return;show(i==null?cur:i);if(lb.showModal){try{lb.showModal();}catch(e){lb.setAttribute('open','');}}else lb.setAttribute('open','');}
      function close(){if(!lb)return;if(lb.close){try{lb.close();}catch(e){lb.removeAttribute('open');}}else lb.removeAttribute('open');}
      if(mainWrap){
        mainWrap.addEventListener('click',function(){open(cur);});
        mainWrap.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();open(cur);}});
      }
      if(moreBtn)moreBtn.addEventListener('click',function(){open(3);});
      if(lb){
        var c=lb.querySelector('[data-ltg-lb-close]');if(c)c.addEventListener('click',close);
        var p=lb.querySelector('[data-ltg-lb-prev]');if(p)p.addEventListener('click',function(){show(cur-1);});
        var n=lb.querySelector('[data-ltg-lb-next]');if(n)n.addEventListener('click',function(){show(cur+1);});
        lb.addEventListener('click',function(e){if(e.target===lb)close();});
        lb.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')show(cur-1);else if(e.key==='ArrowRight')show(cur+1);});
      }
      document.addEventListener('mino:variant',function(e){
        var v=e&&e.detail;if(!v)return;
        for(var i=0;i<images.length;i++){if(String(images[i].id)===String(v.featured_media_id)){setMain(i);break;}}
      });
    });
  }
  if(document.readyState!=='loading')init(document);
  else document.addEventListener('DOMContentLoaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lattogo-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function reset(root){
    (root||document).querySelectorAll('[data-ltg-ugc] [data-ltg-ugc-card] video').forEach(function(v){
      if(v.__ltgControlsReset)return;
      v.__ltgControlsReset=true;
      var hide=function(){v.controls=false;};
      v.addEventListener('pause',hide);
      v.addEventListener('ended',hide);
    });
  }
  if(document.readyState!=='loading')reset(document);
  else document.addEventListener('DOMContentLoaded',function(){reset(document);});
  document.addEventListener('shopify:section:load',function(e){reset(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lattogo-unique-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){function init(scope){scope.querySelectorAll('[data-ltg-unique-section]').forEach(function(root){if(root.__ltgUniqueDestroy)root.__ltgUniqueDestroy();var tabs=Array.from(root.querySelectorAll('[data-ltg-unique-tab]'));var slides=Array.from(root.querySelectorAll('[data-ltg-unique-slide]'));var dots=Array.from(root.querySelectorAll('[data-ltg-unique-dot]'));var stage=root.querySelector('[data-ltg-unique-stage]');var tabRail=root.querySelector('[data-ltg-unique-tabs]');if(!slides.length||!stage)return;var active=0;var startX=null;var controller=new AbortController();var signal=controller.signal;function select(next,focusTab){active=(next+slides.length)%slides.length;slides.forEach(function(slide,index){var difference=index-active;if(difference>1)difference=-1;if(difference<-1)difference=1;slide.style.setProperty('--ltg-unique-offset',difference*100+'%');slide.classList.toggle('is-active',index===active);slide.classList.toggle('is-peek',index!==active);slide.setAttribute('aria-hidden',index===active?'false':'true')});tabs.forEach(function(tab,index){tab.classList.toggle('is-active',index===active);tab.setAttribute('aria-selected',index===active?'true':'false');tab.tabIndex=index===active?0:-1});dots.forEach(function(dot,index){dot.classList.toggle('is-active',index===active);dot.setAttribute('aria-current',index===active?'true':'false')});if(focusTab&&tabs[active])tabs[active].focus();if(tabRail&&tabs[active]&&window.matchMedia('(max-width: 749px)').matches)tabRail.scrollTo({left:tabs[active].offsetLeft-(tabRail.clientWidth-tabs[active].offsetWidth)/2,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}tabs.forEach(function(tab,index){tab.addEventListener('click',function(){select(index,false)},{signal:signal});tab.addEventListener('keydown',function(event){if(event.key==='ArrowRight'){event.preventDefault();select(active+1,true)}else if(event.key==='ArrowLeft'){event.preventDefault();select(active-1,true)}else if(event.key==='Home'){event.preventDefault();select(0,true)}else if(event.key==='End'){event.preventDefault();select(slides.length-1,true)}},{signal:signal})});dots.forEach(function(dot,index){dot.addEventListener('click',function(){select(index,false)},{signal:signal})});stage.addEventListener('pointerdown',function(event){startX=event.clientX},{signal:signal});stage.addEventListener('pointerup',function(event){if(startX!==null&&Math.abs(event.clientX-startX)>50)select(active+(event.clientX<startX?1:-1),false);startX=null},{signal:signal});stage.addEventListener('pointercancel',function(){startX=null},{signal:signal});root.__ltgUniqueSelect=select;root.__ltgUniqueDestroy=function(){controller.abort();delete root.__ltgUniqueSelect;delete root.__ltgUniqueDestroy};select(0,false)})}if(!window.__ltgUniqueCarouselReady){window.__ltgUniqueCarouselReady=true;window.__ltgUniqueCarouselInit=init;document.addEventListener('shopify:section:load',function(event){init(event.target)});document.addEventListener('shopify:section:unload',function(event){var root=event.target.matches('[data-ltg-unique-section]')?event.target:event.target.querySelector('[data-ltg-unique-section]');if(root&&root.__ltgUniqueDestroy)root.__ltgUniqueDestroy()});document.addEventListener('shopify:block:select',function(event){var slide=event.target.closest('[data-ltg-unique-slide]');var root=event.target.closest('[data-ltg-unique-section]');if(slide&&root&&root.__ltgUniqueSelect){root.__ltgUniqueSelect(Number(slide.dataset.ltgUniqueSlide),false);root.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}})}init(document)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lattogo-video-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function initHero(root){all('[data-ltg-hero]',root).forEach(function(sec){if(sec.__ltgBound)return;sec.__ltgBound=true;var videos=all('[data-ltg-hero-video]',sec);var btn=sec.querySelector('[data-ltg-hero-toggle]');function visibleVideo(){return videos.filter(function(v){var st=getComputedStyle(v);var r=v.getBoundingClientRect();return st.display!=='none'&&st.visibility!=='hidden'&&r.width>0&&r.height>0;})[0]||videos[0];}function pauseHidden(active){videos.forEach(function(v){if(v!==active)v.pause();});}function sync(){var v=visibleVideo();if(!btn||!v)return;btn.setAttribute('aria-label',v.paused?'Play hero video':'Pause hero video');var s=btn.querySelector('[data-ltg-play]');if(s)s.textContent=v.paused?'▶':'❚❚';}function play(){var v=visibleVideo();if(!v||reduce)return;v.muted=true;v.setAttribute('muted','');v.playsInline=true;pauseHidden(v);var p=v.play();if(p&&p.catch)p.catch(function(){sync();});sync();}function refresh(){play();sync();}if(btn)btn.addEventListener('click',function(){var v=visibleVideo();if(!v)return;if(v.paused){v.muted=true;v.setAttribute('muted','');v.playsInline=true;var p=v.play();if(p&&p.catch)p.catch(function(){sync();});}else v.pause();sync();});videos.forEach(function(v){v.muted=true;v.setAttribute('muted','');v.playsInline=true;v.addEventListener('play',sync);v.addEventListener('pause',sync);});refresh();window.addEventListener('resize',refresh,{passive:true});window.addEventListener('orientationchange',refresh,{passive:true});window.addEventListener('pageshow',refresh,{passive:true});document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});});}
  function initGallery(root){all('[data-ltg-product]',root).forEach(function(sec){if(sec.__ltgBound)return;sec.__ltgBound=true;var slides=all('[data-ltg-slide]',sec);var thumbs=all('[data-ltg-thumb]',sec);var current=0;var dialog=sec.querySelector('[data-ltg-lightbox]');function show(i){if(!slides.length)return;current=(i+slides.length)%slides.length;slides.forEach(function(s,n){s.classList.toggle('is-active',n===current);s.setAttribute('aria-hidden',n===current?'false':'true');});thumbs.forEach(function(t,n){t.setAttribute('aria-current',n===current?'true':'false');});}thumbs.forEach(function(t,i){t.addEventListener('click',function(){show(i);});});all('[data-ltg-gallery-prev]',sec).forEach(function(b){b.addEventListener('click',function(){show(current-1);});});all('[data-ltg-gallery-next]',sec).forEach(function(b){b.addEventListener('click',function(){show(current+1);});});all('[data-mino-swatch]',sec).forEach(function(b){b.addEventListener('click',function(){var id=b.getAttribute('data-featured-media-id');if(!id)return;slides.forEach(function(s,n){if(s.getAttribute('data-media-id')===id)show(n);});});});function lightboxImage(){var s=slides[current];return s?s.getAttribute('data-image-url'):'';}all('[data-ltg-open-lightbox]',sec).forEach(function(b){b.addEventListener('click',function(){var url=lightboxImage();if(!url||!dialog)return;dialog.querySelector('img').src=url;dialog.showModal();});});if(dialog){var close=dialog.querySelector('[data-ltg-lb-close]');if(close)close.addEventListener('click',function(){dialog.close();});var prev=dialog.querySelector('[data-ltg-lb-prev]');var next=dialog.querySelector('[data-ltg-lb-next]');function nav(d){show(current+d);var u=lightboxImage();if(u)dialog.querySelector('img').src=u;}if(prev)prev.addEventListener('click',function(){nav(-1);});if(next)next.addEventListener('click',function(){nav(1);});dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close();});}show(0);});}
  function initUGC(root){all('[data-ltg-ugc]',root).forEach(function(sec){if(sec.__ltgBound)return;sec.__ltgBound=true;var rail=sec.querySelector('[data-ltg-ugc-rail]');if(!rail)return;var videos=all('video',rail);var prev=sec.querySelector('[data-ltg-ugc-prev]');var next=sec.querySelector('[data-ltg-ugc-next]');function scroll(d){rail.scrollBy({left:d*Math.max(260,rail.clientWidth*.8),behavior:reduce?'auto':'smooth'});}if(prev)prev.addEventListener('click',function(){scroll(-1);});if(next)next.addEventListener('click',function(){scroll(1);});videos.forEach(function(v){var card=v.closest('[data-ltg-ugc-card]');var play=card?card.querySelector('[data-ltg-ugc-play]'):null;if(play)play.addEventListener('click',function(){videos.forEach(function(other){if(other!==v)other.pause();});v.controls=true;var promise=v.play();if(promise&&promise.catch)promise.catch(function(){});});v.addEventListener('play',function(){v.controls=true;if(card)card.classList.add('is-playing');videos.forEach(function(other){if(other!==v)other.pause();});});v.addEventListener('pause',function(){if(card)card.classList.remove('is-playing');});});if('IntersectionObserver'in window){var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting){var v=e.target.querySelector('video');if(v)v.pause();}});},{threshold:.35});all('[data-ltg-ugc-card]',rail).forEach(function(c){io.observe(c);});sec.__ltgObserver=io;}});}
  function init(root){initHero(root);initGallery(root);initUGC(root);}
  if(document.readyState!=='loading')init(document);else document.addEventListener('DOMContentLoaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:section:unload',function(e){all('[data-ltg-hero],[data-ltg-product],[data-ltg-ugc]',e.target).forEach(function(n){if(n.__ltgObserver)n.__ltgObserver.disconnect();delete n.__ltgBound;});});
  document.addEventListener('shopify:section:select',function(e){init(e.target);});
  document.addEventListener('shopify:block:select',function(e){var card=e.target.closest('[data-ltg-ugc-card],.ltg-step,.ltg-detail-card');if(card)card.scrollIntoView({block:'center',inline:'center',behavior:reduce?'auto':'smooth'});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mino-how-to-use"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root || document).querySelectorAll('.mino-tutorial__media').forEach(function(media){
      if(media.__minoTutorialBound) return;
      media.__minoTutorialBound = true;
      var video = media.querySelector('video');
      var button = media.querySelector('[data-mino-tutorial-play]');
      if(!video || !button) return;
      function update(){
        var playing = !video.paused && !video.ended;
        media.classList.toggle('is-playing', playing);
        button.setAttribute('aria-label', playing ? button.getAttribute('data-label-pause') : button.getAttribute('data-label-play'));
      }
      button.addEventListener('click', function(){
        if(video.paused || video.ended) video.play();
        else video.pause();
      });
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      video.addEventListener('ended', update);
      update();
    });
  }
  if(document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(event){ init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mino-sticky-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    (root || document).querySelectorAll('[data-mino-sticky]').forEach(function(bar){
      if(bar.__ltgFloatingBound) return;
      bar.__ltgFloatingBound = true;
      var thumbs = [].slice.call(bar.querySelectorAll('[data-mino-sticky-thumb]'));
      function setActive(id){
        thumbs.forEach(function(thumb){
          thumb.setAttribute('aria-current', String(thumb.getAttribute('data-variant-id')) === String(id) ? 'true' : 'false');
        });
      }
      thumbs.forEach(function(thumb){
        thumb.addEventListener('click', function(){
          var id = thumb.getAttribute('data-variant-id');
          var swatch = document.querySelector('[data-mino-swatch][data-variant-id="' + id + '"]');
          if(swatch) swatch.click();
          setActive(id);
        });
      });
      document.addEventListener('mino:variant', function(event){
        if(event.detail && event.detail.id) setActive(event.detail.id);
      });
    });
  }
  if(document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(event){ init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mino-video-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(sel,root){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}
  function initUGC(root){
    all('[data-ltg-ugc]',root).forEach(function(sec){
      if(sec.__ltgUgcBound)return;
      sec.__ltgUgcBound=true;
      var rail=sec.querySelector('[data-ltg-ugc-rail]');
      if(!rail)return;
      var videos=all('video',rail);
      var prev=sec.querySelector('[data-ltg-ugc-prev]');
      var next=sec.querySelector('[data-ltg-ugc-next]');
      function scroll(d){rail.scrollBy({left:d*Math.max(260,rail.clientWidth*0.8),behavior:reduce?'auto':'smooth'});}
      if(prev)prev.addEventListener('click',function(){scroll(-1);});
      if(next)next.addEventListener('click',function(){scroll(1);});
      videos.forEach(function(v){
        var card=v.closest('[data-ltg-ugc-card]');
        var play=card?card.querySelector('[data-ltg-ugc-play]'):null;
        var coverTime=0,seeded=false;
        function setCover(){
          if(seeded||!isFinite(v.duration)||v.duration<=0)return;
          seeded=true;
          coverTime=Math.max(0.1,Math.min(v.duration-0.1,v.duration*(0.12+Math.random()*0.6)));
          try{v.currentTime=coverTime;}catch(e){}
        }
        v.addEventListener('loadedmetadata',setCover);
        if(v.readyState>=1)setCover();
        function startVideo(){videos.forEach(function(o){if(o!==v)o.pause();});v.controls=true;var p=v.play();if(p&&p.catch)p.catch(function(){});}
        if(play)play.addEventListener('click',startVideo);
        v.addEventListener('click',function(e){
          if(v.paused)return;
          var rect=v.getBoundingClientRect();
          if(e.clientY-rect.top>rect.height-48)return;
          v.pause();
        });
        v.addEventListener('play',function(){v.controls=true;if(card)card.classList.add('is-playing');videos.forEach(function(o){if(o!==v)o.pause();});});
        v.addEventListener('pause',function(){v.controls=false;if(card)card.classList.remove('is-playing');});
        v.addEventListener('ended',function(){v.controls=false;if(card)card.classList.remove('is-playing');try{v.currentTime=coverTime||0;}catch(e){}});
      });
      if('IntersectionObserver'in window){
        var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(!e.isIntersecting){var vv=e.target.querySelector('video');if(vv)vv.pause();}});},{threshold:.35});
        all('[data-ltg-ugc-card]',rail).forEach(function(c){io.observe(c);});
        sec.__ltgObserver=io;
      }
    });
  }
  if(document.readyState!=='loading')initUGC(document);
  else document.addEventListener('DOMContentLoaded',function(){initUGC(document);});
  document.addEventListener('shopify:section:load',function(e){initUGC(e.target);});
  document.addEventListener('shopify:section:unload',function(e){all('[data-ltg-ugc]',e.target).forEach(function(n){if(n.__ltgObserver)n.__ltgObserver.disconnect();delete n.__ltgUgcBound;});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outin-video-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function init(root){
    all('[data-outin-vc]', root).forEach(function(sec){
      if (sec.__ovcBound) return;
      sec.__ovcBound = true;
      var rail = sec.querySelector('[data-outin-vc-rail]');
      if (!rail) return;
      var videos = all('video', rail);
      var prev = sec.querySelector('[data-outin-vc-prev]');
      var next = sec.querySelector('[data-outin-vc-next]');
      function scroll(d){ rail.scrollBy({ left: d * Math.max(240, rail.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function(){ scroll(-1); });
      if (next) next.addEventListener('click', function(){ scroll(1); });
      videos.forEach(function(v){
        var card = v.closest('[data-outin-vc-card]');
        var play = card ? card.querySelector('[data-outin-vc-play]') : null;
        if (play) play.addEventListener('click', function(){
          videos.forEach(function(o){ if (o !== v) o.pause(); });
          v.controls = true;
          var p = v.play();
          if (p && p.catch) p.catch(function(){});
        });
        v.addEventListener('play', function(){ v.controls = true; if (card) card.classList.add('is-playing'); videos.forEach(function(o){ if (o !== v) o.pause(); }); });
        v.addEventListener('pause', function(){ v.controls = false; if (card) card.classList.remove('is-playing'); });
        v.addEventListener('ended', function(){ v.controls = false; if (card) card.classList.remove('is-playing'); v.currentTime = 0; });
      });
      if ('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){ entries.forEach(function(e){ if (!e.isIntersecting){ var vv = e.target.querySelector('video'); if (vv) vv.pause(); } }); }, { threshold: .35 });
        all('[data-outin-vc-card]', rail).forEach(function(c){ io.observe(c); });
        sec.__ovcIO = io;
      }
    });
  }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function(){ init(document); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:section:unload', function(e){ all('[data-outin-vc]', e.target).forEach(function(n){ if (n.__ovcIO) n.__ovcIO.disconnect(); delete n.__ovcBound; }); });
})();

  } catch(e) { console.error(e); }
})();
})();
